import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Alert } from 'react-bootstrap'
import { t } from 'i18next'

import { useCatalogsState } from '../../../stores/Configuration/CatalogsProvider'
import OfficeMultiSelect from '../../General/Office/OfficeMultiSelect'

const StyledWrapper = styled.div`
  @media screen and (min-width: 1080px) {
    max-width: calc(100% - 480px);
    min-width: 600px;
  }
  .search-wrapper{
    padding-left: 0;
    padding-right: 0;
  }
  .action-buttons {
    visibility: visible !important;
  }
`

const CatalogActivateArticle = ({ selectedOffices, setSelectedOffices }) => {
  const { successStates, setSuccessStates, initCatalogActivateArticle } = useCatalogsState()

  useEffect(() => {
    if (successStates.saveCatalogOfficeAvailabilities || successStates.deleteCatalogOfficeAvailabilities) {
      setTimeout(() => {
        setSuccessStates({})
      }, 3000)
    }
  }, [setSuccessStates, successStates]);

  useEffect(() => {
    setSelectedOffices(null)
    initCatalogActivateArticle()
  }, [initCatalogActivateArticle, setSelectedOffices])

  return (
    <>
      <div className="d-flex align-items-center additional">
        <StyledWrapper>
          <OfficeMultiSelect selectedOfficeIds={selectedOffices || []} setSelectedOfficeIds={setSelectedOffices} />
          {successStates.saveCatalogOfficeAvailabilities || successStates.deleteCatalogOfficeAvailabilities ? (
            <Alert variant="success" className="mt-2">
              {t('catalogsAdministration:successMsg')}
            </Alert>
          ) : null}
        </StyledWrapper>
      </div>
    </>
  )
}

export default CatalogActivateArticle